import i18n from '@/plugins/i18n';

function getPaymentColumns(handlers) {
  return getColumns(handlers, paymentColumns);
}

function getFeeTypeColumns(handlers) {
  return getColumns(handlers, feeTypeColumns);
}

function getColumns(handlers, columns) {
  return columns.map((column) => {
    if (column.type === "button") {
      column.actions.forEach((action) => {
        action.handler = getHandler(handlers, action);
      });
    }
    return column;
  });
}

function getHandler(handlers, action) {
  return handlers[action.key] || null;
}

const paymentColumns = [
  {
    text: i18n.t("label.payer_name"),
    value: "payer_name",
    type: "text",
  },
  {
    text: i18n.t("label.payer_email"),
    value: "payer_email",
    type: "text",
  },
  {
    text: i18n.t("label.payment_summary"),
    value: "name",
    type: "text",
  },
  {
    text: i18n.t("label.amount"),
    value: "amount",
    type: "text",
  },
  {
    text: i18n.t("label.currency"),
    value: "currency_code",
    type: "text",
  },
  {
    text: i18n.t("label.approved_at"),
    value: "approved_at",
    type: "text",
  },
  {
    text: i18n.t("label.actions"),
    type: "button",
    actions: [
      {
        icon: "task",
        color: "primary",
        key: "showDetail",
        handler: null,
      },
    ],
  },
];

const feeTypeColumns = [
  {
    text: i18n.t("label.fee_type"),
    value: "name",
    type: "text",
  },
  {
    text: i18n.t("label.amount_krw"),
    value: "fee_krw",
    type: "text",
  },
  {
    text: i18n.t("label.amount_usd"),
    value: "fee_usd",
    type: "text",
  },
  {
    text: i18n.t("label.memo"),
    value: "memo",
    type: "text",
  },
  {
    text: i18n.t("label.created_at"),
    value: "created_at",
    type: "text",
  },
  {
    text: i18n.t("label.actions"),
    type: "button",
    actions: [
      {
        icon: "close",
        color: "red",
        key: "delete",
        handler: null,
      },
    ],
  },
];

export { getPaymentColumns, getFeeTypeColumns };
